<template>
    <div class="blog-detail-container">
        <h1>{{ blog.title }}</h1>
        <div class="aside">
            <span>日期：{{ formatDate(blog.createDate) }}</span>
            <span>浏览：{{ blog.scanNumber }}</span>
            <a href="#data-form-conteiner">评论：{{ blog.commentNumber }}</a>
            <RouterLink :to="{
                name:'CategoryBlog',
                params:{
                    categoryId:blog.category.id
                }
            }">{{ blog.category.name }}</RouterLink>
        </div>
        <div v-html="blog.htmlContent"></div>
    </div>
</template>

<script>
import { formatDate } from "@/utils"
import { RouterLink } from "vue-router";
export default {
    props: {
        blog: {
            type: Object,
            required: true,
        }
    },
    methods:{
        formatDate,
    }
}
</script>

<style scoped lang="less">
@import "../../../style/var.less";
.aside{
    font-size: 12px;
    color:@gray;
    span,a{
        margin-right: 15px;
    }
}
</style>